module.exports = __webpack_public_path__ + "img/174.quality_of_cooking.53a19852.svg";